import axios from "axios";
import { api } from "./api_route";

export const getSingleTracking = async (trackingNumber) => {
  const response = await axios.post(
    `${api}/post/tracking`,
    { trackingNumber },
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};

export const getBulkTracking = async (bulk) => {
  const response = await axios.post(
    `${api}/post/tracking/bulk`,
    { bulk },
    { headers: { "Content-Type": "application/json" } },
  );
  return response.data;
};
